import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule,NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule,ReactiveFormsModule }   from '@angular/forms';
import {NgxMaskModule} from 'ngx-mask';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { TinymceModule } from 'angular2-tinymce';
import{ IntakeRoutingModule } from './intake-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { NgxSortableModule } from 'ngx-sortable'

import { HeaderComponent } from './component/header/header.component';
import { InspectionsOrderComponent } from './component/inspections-order/inspections-order.component'
import { PropertyInfoComponent } from './component/property-info/property-info.component';
import { InspectionsOrderPartiesComponent } from './component/inspections-order-parties/inspections-order-parties.component';
import { PanelComponent } from './component/panel/panel.component';
import { ClientInfoComponent } from './component/client-info/client-info.component';
import { ContactPickerComponent } from './child-component/contact-picker/contact-picker.component';
import { PropertyDetailsComponent } from './component/property-details/property-details.component';
import { SchedulingComponent,CreditCardContent } from './component/scheduling/scheduling.component';
import { InspectionInfoComponent } from './component/inspection-info/inspection-info.component';
import { FindingsComponent } from './component/findings/findings.component';
import { JobInfoComponent, CreditCardContentJobInfo  } from './component/job-info/job-info.component';
import { DiagramComponent } from './component/diagram/diagram.component';
import { CompletionTasksComponent } from './component/completion-tasks/completion-tasks.component';
import { ConfirmComponent } from './component/confirm/confirm.component';
import { OverviewComponent } from './component/overview/overview.component';
import { ConfirmInspectionComponent } from './component/confirm-inspection/confirm-inspection.component';
import { LookupcodeComponent } from './component/lookupcode/lookupcode.component'
import { LookupcodeSecondComponent } from './component/lookupcode-second/lookupcode.component'
import { InspectionReportsComponent } from './component/inspection-reports/inspection-reports.component'
import { CardSharedModule } from '../client/shared/card-shared.module';
import { ChemicalsComponent } from './completion-component/chemicals/chemicals.component';
import { MaterialsComponent } from './completion-component/materials/materials.component';
import { ChemAppHoursComponent } from './completion-component/chem-app-hours/chem-app-hours.component';
import { CrewHoursComponent } from './completion-component/crew-hours/crew-hours.component';
import { SubContractorsComponent } from './completion-component/sub-contractors/sub-contractors.component';
import { AdditionalWorkPerformedComponent } from './completion-component/additional-work-performed/additional-work-performed.component';
import { FindingsModelComponent } from './completion-component/findings-model/findings-model.component';
import { FindingsChemicalsAppliedModelComponent } from './completion-component/findings-chemicals-applied-model/findings-chemicals-applied-model.component';
import { JobOrderComponent } from './child-component/job-order/job-order.component';
import { InspectionStatusComponent } from './child-component/inspection-status/inspection-status.component';
import { ReportPaymentComponent } from './child-component/report-payment/report-payment.component';
import { ChangeEscrowComponent } from './child-component/change-escrow/change-escrow.component';
import { InspectionTypeComponent } from './child-component/inspection-type/inspection-type.component';
import { ChangeInspectorComponent } from './child-component/change-inspector/change-inspector.component';
import { IntakeHeaderComponent } from './component/panel/intake-header/intake-header.component';
import { CreditCardFeesComponent } from './completion-component/credit-card-fees/credit-card-fees.component';
// Overview page panels (see component/overview/overview-panels.ts)
import { OverviewPanelComponent } from './component/overview/panel-shell/overview-panel.component';
import { OverviewPropertyComponent } from './component/overview/panels/property/overview-property.component';
import { OverviewInspectionComponent } from './component/overview/panels/inspection/overview-inspection.component';
import { OverviewScheduleInspectionComponent } from './component/overview/panels/schedule-inspection/overview-schedule-inspection.component';
import { OverviewOrderedByComponent } from './component/overview/panels/ordered-by/overview-ordered-by.component';
import { OverviewInterestedPartiesComponent } from './component/overview/panels/interested-parties/overview-interested-parties.component';
import { OverviewReportsComponent } from './component/overview/panels/reports/overview-reports.component';
import { OverviewAccountingComponent } from './component/overview/panels/accounting/overview-accounting.component';
import { OverviewActionComponent } from './component/overview/panels/action/overview-action.component';
import { OverviewJobCostComponent } from './component/overview/panels/job-cost/overview-job-cost.component';
import { OverviewNotesComponent } from './component/overview/panels/notes/overview-notes.component';
import { InspectionLogsComponent } from './component/inspection-logs/inspection-logs.component';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { JobProofedComponent } from './child-component/job-proofed/job-proofed.component';
import {SharedModule} from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IntakeRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    CardSharedModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyBOPZbXMZdO9rqYZT007G2DIw2a6Nppbhw',
    //   libraries:['places']
    // }),
    TinymceModule.withConfig({}),
    NgxSortableModule,
    NgxDnDModule,
    SharedModule
  ],
  providers: [
    GoogleMapsAPIWrapper // <---
  ],
  declarations: [
    HeaderComponent,
    PropertyInfoComponent,
    InspectionsOrderComponent,
    InspectionsOrderPartiesComponent,
    PanelComponent,
    ClientInfoComponent,
    ContactPickerComponent,
    PropertyDetailsComponent,
    SchedulingComponent,
    InspectionInfoComponent,
    FindingsComponent,
    JobInfoComponent,
    DiagramComponent,
    CompletionTasksComponent,
    ConfirmComponent,
    OverviewComponent,
    ConfirmInspectionComponent,
    LookupcodeComponent,
    LookupcodeSecondComponent,
    InspectionReportsComponent,
    CreditCardContent,
    ChemicalsComponent,
    MaterialsComponent,
    ChemAppHoursComponent,
    CrewHoursComponent,
    SubContractorsComponent,
    AdditionalWorkPerformedComponent,
    FindingsModelComponent,
    FindingsChemicalsAppliedModelComponent,
    JobOrderComponent,
    InspectionStatusComponent,
    ReportPaymentComponent,
    ChangeEscrowComponent,
    OverviewInterestedPartiesComponent,
    OverviewPropertyComponent,
    OverviewInspectionComponent,
    InspectionTypeComponent,
    ChangeInspectorComponent,
    OverviewNotesComponent,
    OverviewJobCostComponent,
    OverviewScheduleInspectionComponent,
    OverviewReportsComponent,
    CreditCardContentJobInfo,
    IntakeHeaderComponent,
    CreditCardFeesComponent,
    JobProofedComponent,
    OverviewPanelComponent,
    OverviewOrderedByComponent,
    OverviewAccountingComponent,
    OverviewActionComponent,
    InspectionLogsComponent
  ],
  exports: [
    IntakeHeaderComponent
  ],
  entryComponents: [
    LookupcodeComponent,
    LookupcodeSecondComponent,
    CreditCardContent,
    ChemicalsComponent,
    MaterialsComponent,
    ChemAppHoursComponent,
    CrewHoursComponent,
    SubContractorsComponent,
    AdditionalWorkPerformedComponent,
    FindingsModelComponent,
    FindingsChemicalsAppliedModelComponent,
    CreditCardContentJobInfo,
    InspectionStatusComponent,
    ReportPaymentComponent,
    ChangeEscrowComponent,
    OverviewPropertyComponent,
    ChangeInspectorComponent,
    InspectionTypeComponent,
    OverviewNotesComponent,
    OverviewJobCostComponent,
    OverviewScheduleInspectionComponent,
    CreditCardFeesComponent,
    JobProofedComponent
  ]
})
export class IntakeModule { }
